import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import ContactRowSkeleton from './ContactRowSkeleton';
import './ContactRoleGroup.scss';

interface ContactRoleGroupSkeletonProps {
  rowCount?: number;
}

const ContactRoleGroupSkeleton = ({
  rowCount = 3,
}: ContactRoleGroupSkeletonProps) => (
  <section className="contact-role-group" aria-hidden>
    <div className="group-header">
      <Skeleton variant="text" width="8rem" />
    </div>

    {Array.from({ length: rowCount }, (_, index: number) => (
      <ContactRowSkeleton key={`contact-row-skeleton-${index}`} />
    ))}
  </section>
);

export default ContactRoleGroupSkeleton;
